import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { isDesktop } from "react-device-detect";

//Miscellaneous
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { Reveal } from "react-awesome-reveal";
import { keyframes } from "@emotion/react";

//Components
import SideBar from "../../components/Sidebar/Sidebar";
import BankingDetails from "./BankingDetails";
import CryptoDetails from "./CryptoDetails";
import MobileMyWallet from "./MobileMyWallet";

import { getWallet } from "../../store/ducks/wallet/actions";

class MyWallet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageShow: "banking_details",
            loading: true,
            login: localStorage.getItem("accessToken") ? true : false,
            data: [],
            showNum: false,
        };
    }

    componentDidMount() {
        this.props.getWallet();

        if (this.state.login) {
            this.walletInterval = setInterval(() => {
                this.props.getWallet();
            }, 10000);
        } else {
            clearInterval(this.walletInterval);
        }
    }

    componentWillUnmount() {
        clearInterval(this.walletInterval);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if(nextProps.get_wallet !== undefined && nextProps.get_wallet !== this.props.get_wallet){
            if(nextProps.get_wallet.responseCode === 200 && nextProps.get_wallet.msgType === 'success'){
                this.setState({
                    loading: false,
                    data: nextProps.get_wallet.data.result
                });
            }
        }
        return true;
    }

    imageImport = (r) => {
        let images = {};
        r.keys().map((item, index) => {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    };

    changeTabHandler = (e) => {
        e.preventDefault();
        this.setState({
            pageShow: e.target.id,
        });
    };

    onInputChangeHandler = (event) => 
	{
        // console.log(event.target.name+' | '+event.target.value)
		if (event.target.name === 'showNum') 
        {
            this.setState({
                showNum: !this.state.showNum,
                errorMsg: [],
                formError: false,
                converted_currency: "",
                converted_amount: "",
            });
        }
        else 
        {
            this.setState({
                [event.target.name]: event.target.value,
                errorMsg: [],
                formError: false,
                converted_currency: "",
                converted_amount: ""
            });
        }

        if(event.target.name === 'amount'){
            if(this.state.memberId !== null && this.state.memberId !== "" && this.state.memberId !== undefined && event.target.value > 0){
                let data = {};
                data.member_id = this.state.memberId;
                data.amount = event.target.value;
                this.props.getCurrencyExchange(data);
            }
        }
	}

    render() {
        const { t } = this.props;
        const icons = this.imageImport(require.context("../../assets/images/deposit/icons", false, /\.(png|jpe?g|svg)$/));
        const img = this.imageImport(require.context("../../assets/images/loginregister/", false, /\.(png|jpe?g|svg|webp)$/));

        const fadeUp = keyframes`
            from {
            opacity: 0;
            transform: translate3d(0, 50px ,0);
            }
    
            to {
            opacity: 1;
            transform: translate3d(0, 0, 0);
            }
        `;

        return (
            <Auxiliary>
                {isDesktop ? (
                    <section className="pf-dashboard">
                        <div className="x-container">
                            <SideBar />
                            <Reveal className="pf-fade-col" keyframes={fadeUp} duration={1000} triggerOnce>
                                <div className="row g-3">
                                    <div className="col-12">
                                        <div className="pd-card-col">
                                            <h4>{t("wallet.my-wallet")}</h4>
                                            <div className="pd-content">
                                                <div className="my-wallet-col">
                                                    <div className="row g-3">
                                                        <div className="col-6">
                                                            <div className="quota-deposit-container ">
                                                            <div className="available-amount-content">
                                                                    <img className="active" src={icons["wallet-ico.svg"]} alt="wallet-ico" />
                                                                    <div className="amount-body w-100">
                                                                   
                                                                        <label>{t("wallet.wallet")}</label>
                                                                        {this.state.loading ? (
                                                                                <Skeleton count={1} height={20} />
                                                                            ) : (
                                                                        <div className="amount">
                                                                           {this.state.showNum ? 
                                                                                <p>
                                                                                {this.props.currentUser.currency}
                                                                                <span className="ms-2">
                                                                                    {Intl.NumberFormat("en-US", { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(this.state.data)}
                                                                                </span>
                                                                                </p>
                                                                                : 
                                                                                    '*******'} 
                                                                        <img
                                                                            className="show-hide-btn"
                                                                            src={img[`${(!this.state.showNum) ? 'close-' : ''}eye.png`]}
                                                                            alt="hide pwd"
                                                                            id="showNum"
                                                                            name="showNum"
                                                                            onClick={(event) => this.onInputChangeHandler(event)}
                                                                        />
                                                                    </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="pd-card-col">
                                            {/* <h6>{t("account-details.account-details")}</h6> */}
                                            <div className="pd-content">
                                                <div className="fd-col">
                                                    <ul className="nav nav-tabs" role="tablist">
                                                        <li className="nav-item" role="presentation">
                                                            <button
                                                                className="nav-link active"
                                                                id="banking_details"
                                                                data-bs-toggle="tab"
                                                                data-bs-target="#banking-details"
                                                                type="button"
                                                                role="tab"
                                                                aria-controls="banking-details"
                                                                aria-selected="true"
                                                                onClick={(event) => this.changeTabHandler(event)}
                                                            >
                                                                {t("account-details.banking-details")}
                                                            </button>
                                                        </li>

                                                        {/* <li className="nav-item" role="presentation">
                                                            <button
                                                                className="nav-link"
                                                                id="crypto_details"
                                                                data-bs-toggle="tab"
                                                                data-bs-target="#crypto-details"
                                                                type="button"
                                                                role="tab"
                                                                aria-controls="crypto-details"
                                                                aria-selected="false"
                                                                onClick={(event) => this.changeTabHandler(event)}
                                                            >
                                                                {t("account-details.crypto-details")}
                                                            </button>
                                                        </li> */}
                                                    </ul>
                                                    <div className="tab-content">
                                                        {this.state.pageShow === "banking_details" && <BankingDetails />}
                                                        {/* {this.state.pageShow === "crypto_details" && <CryptoDetails />} */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Reveal>
                        </div>
                    </section>
                ) : (
                    <MobileMyWallet
                        {...this.state}
                        {...this.props}
                    />
                )}
            </Auxiliary>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        get_wallet: state.wallet.get_wallet
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getWallet: () => dispatch(getWallet())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(MyWallet));
